import { render } from "./TransportationForm.vue?vue&type=template&id=84cf3d8a&scoped=true"
import script from "./TransportationForm.vue?vue&type=script&lang=js"
export * from "./TransportationForm.vue?vue&type=script&lang=js"

import "./TransportationForm.vue?vue&type=style&index=0&id=84cf3d8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-84cf3d8a"

export default script